export const ADD_SESSION = 'ADD_SESSION';
export const REMOVE_SESSION = 'REMOVE_SESSION';
export const INVALID_SESSION = 'INVALID_SESSION';
export const LIMIT_REACHED = 'LIMIT_REACHED';

export interface AddSessionAction<T = unknown> {
  type: typeof ADD_SESSION;
  data: T;
}

export interface RemoveSessionAction {
  type: typeof REMOVE_SESSION;
}

export interface InvalidSessionAction {
  type: typeof INVALID_SESSION;
}

export interface LimitReachedAction {
  type: typeof LIMIT_REACHED;
}

export type SessionAction =
  | AddSessionAction
  | RemoveSessionAction
  | InvalidSessionAction
  | LimitReachedAction;

export function addSession<T>(data: T): AddSessionAction<T> {
  return {
    type: ADD_SESSION,
    data,
  };
}

export function removeSession(): RemoveSessionAction {
  return {
    type: REMOVE_SESSION,
  };
}

export function invalidSession(): InvalidSessionAction {
  return {
    type: INVALID_SESSION,
  };
}

export function limitReached(): LimitReachedAction {
  return {
    type: LIMIT_REACHED,
  };
}
